<template>
    <div id="homepage" :key="last_update_time">
        <div id="hero">
          <div class="logo"></div>
        </div>

      <div class="centered" v-if="loaded">

        <div id="live_events" :key="currtime">
          <div class="container-fluid">
          <div class="row">
          <div v-for="maslul in items_live" :key="maslul.id" class="col-md-4 col-xs-12 item">
            
            <template  v-if="maslul[0] != undefined">
              <router-link :to="maslul[0].link">
              <a class="play"></a>
              <a class="zoom"></a>
              <div class="pic" :style="'background-image:url(' + maslul[0].pic_tumb + ')'"></div>
              <h3 class="title" v-text="maslul[0].title"></h3>
              <div class="lecturers_foot" :data-num="maslul[0].lecturers.length">
                  <div class="lect_strip" v-for="lect in maslul[0].lecturers" :key="lect.id">
                    <h3><strong v-text="lect.name"></strong> <span v-text="lect.job"></span></h3>
                    <div class="logo"><span :style="'background-image:url(' + lect.job_icon_tumb + ')'"></span></div>
                  </div>
              </div>
            </router-link>
            </template>
          </div>
          </div>
          </div>
        </div>

        <div id="logos_strip">LOGOS</div>

        <!-- <input type="number" v-model="currtime"> -->

        <div id="hp_strips"> 
          
          <div class="">
          <div class="row">
            <div class="col-md-4">
              <h3 class="strip_ttl"><strong>מסלול 1</strong> | ההרצאות הבאות</h3>
              <maslulStrip :items="next_a" :key="last_update_time"></maslulStrip>
            </div>
            
            <div class="col-md-4">
              <h3 class="strip_ttl" style="background-color:#f2a73d"><strong>מסלול 2</strong> | ההרצאות הבאות</h3>
              <maslulStrip :items="next_b" :key="last_update_time"></maslulStrip>
            </div>
            
            <div class="col-md-4">
              <h3 class="strip_ttl" style="background-color:#eb4c4c"><strong>מסלול 3</strong> | ההרצאות הבאות</h3>
              <maslulStrip :items="next_c" :key="last_update_time"></maslulStrip>
            </div>
          </div>
          </div>
        </div>

      </div>

      <div id="hp_footer">
        &copy; כל הזכויות שמורות למרכז הנדל"ן 2020
      </div>

    </div>
</template>

<script>
import maslulStrip from './maslul_strip.vue'
export default {
  components: { maslulStrip },
  data() {
    return {
      loaded: false,
      is_test: true,
      currtime: Math.floor(Date.now() / 1000),
      items: [ ],
      last_update_time: Date.now()
    };
  },
  computed:{
    items_live() {
      var ret = {1: [], 2: [], 3: []}
      for (let i in this.items) 
      {
        let item = this.items[i];
        
        if (item.start_hour_unix <= this.currtime && item.end_hour_unix >= this.currtime)
        {  
            ret[item.maslul].push(item);
        }

      }
      
      return ret;
    },
    next_a() {
      return this.get_strip(1);
    },
    next_b() {
      return this.get_strip(2);
    },
    next_c() {
      return this.get_strip(3);
    }
  },
  created() {

    var self = this;
     if(this.is_test) this.currtime = 1601108100; //this.items[0].start_hour_unix;
     
    
    if (!this.is_test)
    {
      setInterval(function(){
          self.currtime = Math.floor(Date.now() / 1000);
      }, 5*1000);
    }
    // categories 
    this.api_call({ url: 'home', onComplete: function(data){

      self.items = data.data.data.items;

      self.loaded = true;
    } } );

    this.$pnSubscribe({
        channels: ['psg'],
    });

        
    this.$pnGetMessage('psg', this.parse_updates);

    

  },
  methods: {
    get_strip(id)
    {
      var ret = [];
      for (let i in this.items) 
      {
        let item = this.items[i];
        
        if (item.maslul == id && item.start_hour_unix > this.currtime)
        {  
            ret.push(item);
        }
      }
      
      return ret;
    },
    parse_updates(msg)
    {
      var data = JSON.parse(msg.message);
      console.log(data);

      switch(data.mtype)
      {
        case 'update_time': { this.update_event_data(data.data.id, data.data);  break; }
        case 'refresh_page': { document.location.reload();  break; }
        case 'alert': { alert(data.data);  break; }
      }
    },
    update_event_data(id, data)
    {
      for (let i in this.items) 
      {
        let item = this.items[i];
        
        if (item.id == id) 
        {
          this.items[i] = data;
          this.last_update_time = Date.now();
          //this.currtime = 1601109100
          break;
        }

      }
    }
  }
}
</script>